import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }
  static targets = ["confirm"]

  copy() {
    navigator.clipboard.writeText(this.textValue).then(() => {
      // Icon buttons pass a "confirm" target (a small popover) so the copy
      // click doesn't clobber the icon itself -- text-only buttons (e.g. the
      // session join link) fall back to the original whole-element swap.
      if (this.hasConfirmTarget) {
        this.confirmTarget.classList.remove("hidden")
        clearTimeout(this._hideTimer)
        this._hideTimer = setTimeout(() => this.confirmTarget.classList.add("hidden"), 1500)
      } else {
        const original = this.element.textContent
        this.element.textContent = "Copied!"
        setTimeout(() => { this.element.textContent = original }, 1500)
      }
    })
  }
}
